import { capfirst } from 'journalize';
import { LENGTH_OF_CHECK_INTERVAL } from './constants';

const PARTY_SORT_ORDER = [
  'democrat',
  'republican',
  'libertarian',
  'independent',
  'write-in',
];

const TT_directory_slugs = [
  { office: 'Texas House', 'directory-slug': 'tx-house' },
  { office: 'Texas Senate', 'directory-slug': 'tx-senate' },
  { office: 'U.S. House', 'directory-slug': 'us-house' },
  { office: 'State Board of Education', 'directory-slug': 'sboe' },
];

export function get_directory_slug(office) {
  return TT_directory_slugs.filter(slug => slug.office == office);
}

export function sort_candidates_by_party(candidates) {
  return candidates.sort(
    (a, b) =>
      PARTY_SORT_ORDER.indexOf(a.party) - PARTY_SORT_ORDER.indexOf(b.party)
  );
}

export function countdown(minutes) {
  var seconds = 60;

  var now = new Date().getTime();
  // target timestamp; we will compute the remaining time
  // relative to this date.
  var target = new Date(now + LENGTH_OF_CHECK_INTERVAL);
  // update frequency; note, this is flexible, and when the tab is
  // inactive, there are no guarantees that the countdown will update
  // at this frequency.
  var update = 500;

  var int = setInterval(function() {
    var countdown_div = document.querySelectorAll('.countdown');
    // current timestamp
    var now = new Date();
    // remaining time, in seconds
    var remaining = (target - now) / 1000;

    // if done, alert
    if (remaining < 1 && remaining > 0) {
      Array.prototype.forEach.call(countdown_div, function(el) {
        el.innerHTML = 'Updating';
      });
      return;
    }

    if (remaining < 0) {
      clearInterval(int);
      return;
    }

    // format
    var minutes = ~~(remaining / 60);
    var seconds = ~~(remaining % 60);

    // display
    Array.prototype.forEach.call(countdown_div, function(el) {
      el.innerHTML =
        "Update in <span class='counter'>" +
        format(minutes) +
        ':' +
        format(seconds) +
        '</span>';
    });
  }, update);
}

function format(num) {
  return num < 10 ? '0' + num : num;
}

//   function tick() {
//     var counter = document.querySelectorAll('.counter');
//     var countdown_div = document.querySelectorAll('.countdown');
//     var current_minutes = minutes - 1;

//     seconds--;

//     Array.prototype.forEach.call(countdown_div, function(el) {
//       el.innerHTML = "Update in <span class='counter'>" +
//         current_minutes.toString() +
//         ':' +
//         (seconds < 10 ? '0' : '') +
//         String(seconds) + "</span>"
//     });

//     if (seconds > 0) {
//       setTimeout(tick, 1000);
//     } else {
//       if (minutes > 1) {
//         countdown(minutes - 1);
//       }
//       if (minutes == 1 && seconds == 0) {
//         Array.prototype.forEach.call(countdown_div, function(el) {
//       el.innerHTML = "Updating"
//     });
//       }
//     }
//   }
//   tick();
// }

export function determineDistrictTitle(contest) {
  return `${contest.office} ${
    contest.office === 'President' || contest.division_type === 'class'
      ? ''
      : contest.division_type === 'place' && contest.office_division === 1
      ? 'Chief Justice'
      : capfirst(contest.division_type) + ' ' + contest.office_division
  }`.trim();
}

export function determineDistrictTitleYourRaces(contest) {
  return `${
    contest.office === 'President' || contest.division_type === 'class'
      ? ''
      : contest.division_type === 'place' && contest.office_division === 1
      ? 'Chief Justice'
      : capfirst(contest.division_type) + ' ' + contest.office_division
  }`.trim();
}
  

export function determineDistrictTitleRunoff(contest) {
  return `${
    contest.office === 'President' || contest.division_type === 'class'
      ? ''
      : contest.division_type === 'place' && contest.office_division === 1
      ? 'Chief Justice'
      : 'District ' + contest.office_division
  }`.trim();
}

export function determineContestTitle(contest) {
  if (
    contest.division_type === 'statewide' ||
    contest.division_type === 'seat' ||
    contest.division_type === 'class'
  )
    return '';

  return determineDistrictTitleRunoff(contest);
}

export function determineContestTitleYourRaces(contest) {
  return determineDistrictTitleYourRaces(contest);
}
